var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwsS3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66891 4.16199L2.07141 4.96449V19.0026L3.66891 19.7981L3.68204 19.785V4.17511L3.66891 4.16199Z",
    fill: "#8C3123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2302 17.76L3.66895 19.7981V4.16199L12.2302 6.15464V17.76Z",
    fill: "#E05243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37048 14.5711L12 15.0314L12.0197 14.9784L12.046 9.0281L12 8.98169L8.37048 9.43544V14.5711Z",
    fill: "#8C3123"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.7862L20.3245 19.8051L20.3377 19.785V4.17511L20.3245 4.16199L12 6.18089V17.7862Z",
    fill: "#8C3123"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6295 14.5711L12 15.0314V8.98169L15.6295 9.43544V14.5711Z",
    fill: "#E05243"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6295 6.95005L12 7.61427L8.37048 6.95005L11.9935 6.00317L15.6295 6.95005Z",
    fill: "#5E1F18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6295 17.0498L12 16.379L8.37048 17.0498L11.9935 18.0623L15.6295 17.0498Z",
    fill: "#F2B0A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37048 6.95016L12 6.05578L12.0263 6.04266V0.02625L12 0L8.37048 1.815V6.95016Z",
    fill: "#8C3123"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6295 6.95016L12 6.05578V0L15.6295 1.815V6.95016Z",
    fill: "#E05243"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.0001L8.37048 22.1851V17.0499L12 17.9443L12.0525 18.0099L12.0394 23.8951L12 24.0001Z",
    fill: "#8C3123"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.0001L15.6295 22.1851V17.0499L12 17.9443V24.0001Z",
    fill: "#E05243"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3245 4.16199L21.9285 4.96449V19.0026L20.3245 19.8051V4.16199Z",
    fill: "#E05243"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsS3);
export default __webpack_public_path__ + "static/media/aws-s3.c93fef7b54a27caa5c660f326c4b2af4.svg";
export { ForwardRef as ReactComponent };